export const BUSINESS_HOURS_EARLIEST_DEFAULT = '00:00:00'
export const BUSINESS_HOURS_LATEST_DEFAULT = '23:59:00'
export const BUSINESS_HOURS_MIN_INTERVAL_DEFAULT = '01:00:00'
export const BUSINESS_HOURS_MIN_FIX_INTERVAL_TIME = '00:15:00'
export const MINUTE_STEP = 30
export const DEFAULT_CUSTOMER_REFERENCE = ''
export const BUSINESS_HOURS_CUT_OFF_TIME_THRESHOLD = '04:00:00'
export const BUSINESS_HOURS_CANCELLATION_CUT_OFF_TIME_THRESHOLD = '04:00:00'
